<template>
  <div class="business-order main-bg">
    <div class="main-wrap">
      <div class="mt20">
        <business-menu></business-menu>
        <div class="fr order-r">
          <div class="order-box">
            <ul class="fl order-nav">
              <li
                      v-for="(item,index) in orderNav"
                      :key="index"
                      :class="{'active':item.status==currentStatus}" @click="getCurrentOrderList(item.status)">{{item.name}}</li>

            </ul>
            <div class="fr btn-blank-list" @click="showBlankList()"><i class="el-icon-s-custom"></i>拉黑列表</div>
          </div>
          <!--<div class="order-query mb20">
            <el-input placeholder="请输入订单关键字" v-model="orderKey">
              <el-button slot="append">搜索订单</el-button>
            </el-input>
          </div>-->
          <order-item @change="getOrderForShop()" role="shop" :orderList="orderList" :nowTime="nowTime" v-if="orderList.length>0"></order-item>
          <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="current"
                  layout=" prev, pager, next,total, jumper"
                  style="text-align: center;padding:20px;"
                  :hide-on-single-page="isTotalOnePage"
                  :total="totalPage">
          </el-pagination>
        </div>
      </div>

    </div>
    <el-dialog title="拉黑列表" :visible.sync="blankListVisible" width="450px">
      <el-table :data="blankListData">
        <el-table-column property="user.nickName" label="姓名"></el-table-column>
        <el-table-column property="user.phone" label="手机号"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="cancelPullBlack(scope.row)" type="text" size="small">取消拉黑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>
<script>
  import BusinessMenu from '../../components/setting/businessMenu'
  import OrderItem from '../../components/order/orderItem.vue'
  import {getShopInfoForMe,getMyPullBlackPage,cancelPullBlack} from '../../api/shop'
  import {allOrderForShop} from '../../api/order'
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
              activeOrder: 'allOrder',
              pendingOrder:0,
              backOrder:0,
              pinJiaOrder:0,
              shouHouOrder:0,
              orderList:[],
              nowTime:'',
              totalPage:0,
              current:1,
              size:10,
              orderKey:'',//订单关键字
              currentStatus:-1,
              orderNav:[
                  {
                      name:'全部',
                      status:-1
                  },
                  {
                      name:'待付款',
                      status:0
                  },
                  {
                      name:'待发货',
                      status:1
                  },
                  {
                      name:'待收货',
                      status:2
                  },
                  {
                      name:'待评价',
                      status:3
                  },
                  {
                      name:'已完成',
                      status:4
                  },
                  {
                      name:'线下订单',
                      status:9
                  },
                  {
                      name:'售后',
                      status:5
                  },
                  {
                      name:'已失效',
                      status:6
                  }
              ],
              blankListVisible:false,
              blankListData:[],
              isTotalOnePage:false,
          }
      },
      components:{
          BusinessMenu,
          OrderItem
      },
      created () {
          this.getShopForMe();
          this.getOrderForShop();
      },
      methods:{
          handleCurrentChange(current){
              this.current=current;
              this.getOrderForShop();
          },
          getShopForMe(){
              getShopInfoForMe({
                  shopId:this.userInfo.shopId
              }).then(res=>{
                  this.pendingOrder=res.data.orderOneCount;
                  this.backOrder=res.data.orderTwoCount;
                  this.pinJiaOrder=res.data.orderThreeCount;
                  this.shouHouOrder=res.data.orderFourCount;
              })
          },
          getOrderForShop(){
              let params={
                  current:this.current,
                  size:this.size,
                  status:this.currentStatus
              };
              if(this.currentStatus===-1){
                  delete params.status;
              }
              if(this.currentStatus==9){
                  delete params.status;
                  params.payType=5;
              }
              allOrderForShop(params).then(res=>{
                  this.totalPage=res.data.total;
                  this.isTotalOnePage=res.data.total<this.size?true:false;
                  this.nowTime=res.nowTime;
                  this.orderList=res.data.records;
              })
          },
          getCurrentOrderList(status){
              if(this.currentStatus!==status){
                  this.currentStatus=status;
                  this.current=1;
                  this.getOrderForShop();
              }

          },
          showBlankList(){
              this.blankListVisible=true;
              this.getMyPullBlackPage()
          },
          getMyPullBlackPage(){
              getMyPullBlackPage({
                  shopId:this.userInfo.shopId
              }).then(res=>{
                  this.blankListData=res.data.records;
              })
          },
          cancelPullBlack(row){
              this.$confirm('确认取消拉黑用户？')
                  .then(()=> {
                      cancelPullBlack({
                          pullBlackId:row.id
                      }).then((res)=>{
                          this.$message({
                              message:res.msg,
                              type:'success'
                          });
                          this.getMyPullBlackPage();
                      }).catch(err=>err);
                  }).catch(() => {});
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/common";

  .order-r{
    /*width:920px;*/
    width:1000px;
    padding:30px 40px 50px;background-color:#ffffff;
    .order-box{
      overflow: hidden;
      padding-bottom:26px;
      .order-nav{
        overflow: hidden;
        li{
          cursor: pointer;
          float: left;font-size:16px;color:#333;
          margin-right:47px;
          height:40px;
          &.active{
            color:$main-color;
            font-size:19px;
            position: relative;
            &:after{
              content: '';
              position: absolute;
              bottom:6px;
              left:0;
              width:100%;
              height:3px;
              background-color:$main-color;
              -webkit-border-radius: 2px;
              -moz-border-radius: 2px;
              border-radius: 2px;
            }
          }
        }
      }
      .btn-blank-list{
        font-size:12px;
        color:#333;
        i{font-size:18px;color:#999999}
      }
    }


  }
</style>
<style lang="scss">
  @import "../../assets/css/common";
  .order-query{
    width:230px;height:30px;
    border:1px solid #E0E0E0;
    .el-input__inner{
      font-size:12px;
      height:30px;
      line-height:30px;border:none;}
    .el-input-group__append, .el-input-group__prepend{
      font-size:12px;
      background-color:#F5F5F5;
      width:46px;
      padding:0 10px;
      border:none;
      color:#333;
      -webkit-border-radius: 0px;
      -moz-border-radius: 0px;
      border-radius: 0px;
    }
  }
</style>

